import {DisplayBenutzerPipe} from './displayBenutzer.pipe';
import {NgModule} from '@angular/core';
import {DisplayBenutzerListePipe} from './displayBenutzerListe.pipe';

@NgModule({
    declarations: [
        DisplayBenutzerPipe,
        DisplayBenutzerListePipe
    ],
    imports: [],
    exports: [
        DisplayBenutzerPipe,
        DisplayBenutzerListePipe
    ]
})
export class PipesSharedModule {}
